import React, {FC} from 'react';
import {formatDateMMDDyyyy} from '../../../util/DateUtils';
import {
  CollapsableCardBodyContainer,
  CollapsableCardClickableContainer,
  CollapsableCardCollapseContainer,
  CollapsableCardContainer,
  CollapsableCardExpandIconButton,
  CollapsableCardHeaderActionsContainer,
  CollapsableCardHeaderContainer,
} from "@securspace/securspace-ui-kit";
import {
  CollapsableCardBodyItem,
  CollapsableCardHeaderItem
} from "../../cardComponents";
import {AdminAccountReportVO} from "../../../types/admin/AdminAccountReportVO";
import AdminAccountReportCardActions from './actions/AdminAccountReportCardActions';
import { DialogType } from './actions/data';
import {DateFormats} from "../../constants/securspace-constants";
import moment from "moment";

type AccountCardListCardListItemProps = {
  account: AdminAccountReportVO;
  collapse: boolean;
  onToggleCollapse: () => void;
  setOpenModal: (modal: DialogType) => void;
  isSuperAdmin: boolean;
  setAccountBeingActioned: (account: AdminAccountReportVO) => void;
}

/**
 * Component that displays all information for a single Account in a collapsable card format
 * @param account the account to display
 * @param collapse variable to determine whether the collapsable part of the container is collapsed or not
 * @param onToggleCollapse callback that is called when the item should be toggled
 * @param setOpenModal callback that is called when a menu action is selected
 * @param isSuperAdmin a boolean to conditionally render some menu options
 * @param setAccountBeingActioned callback that is called when a menu action is selected and receives an account as an argument
 * @constructor
 */
const AccountCardListCardListItem: FC<AccountCardListCardListItemProps> = ({ account, collapse, onToggleCollapse, setOpenModal, isSuperAdmin, setAccountBeingActioned }) => {
  return <CollapsableCardContainer expanded={collapse}>
    <CollapsableCardClickableContainer onClick={onToggleCollapse}>
      <CollapsableCardHeaderContainer>
        <CollapsableCardHeaderItem label={'COMPANY NAME'} value={account.companyName} />
        <CollapsableCardHeaderItem label={'COMPANY EMAIL'} value={account.email} />
        <CollapsableCardHeaderItem label={'ACCOUNT ID'} value={account.id} />
        <CollapsableCardHeaderItem label={'STATUS'} value={account.activated ? "Active" : 'Inactive'} />
        <CollapsableCardHeaderItem label={'ACCOUNT TYPE'} value={account.userType} />
        <CollapsableCardHeaderItem label={'OWNER USERNAME'} value={account.username} />
        <CollapsableCardHeaderActionsContainer>
          <CollapsableCardExpandIconButton expanded={collapse} />
        </CollapsableCardHeaderActionsContainer>
      </CollapsableCardHeaderContainer>
    </CollapsableCardClickableContainer>
    <CollapsableCardCollapseContainer in={collapse}>
      <CollapsableCardBodyContainer>
        <CollapsableCardBodyItem label={'CREATED ON'} value={formatDateMMDDyyyy(moment(account.creationDate, DateFormats.DAY))} />
        <CollapsableCardBodyItem label={'AVATAX CUSTOMER CODE'} value={account.customerCode} />
        <CollapsableCardBodyItem label={'TERMS OF USE AGREED ON'} value={account.termsAgreedToDate} />
        <CollapsableCardBodyItem label={'TERMS OF USE'} value={account.termsVersion} />
        <CollapsableCardBodyItem label={'PRIVACY POLICY AGREED ON'} value={account.privacyPolicyAgreeToDate} />
        <CollapsableCardBodyItem label={'PRIVACY POLICY'} value={account.policyVersion} />
        <CollapsableCardHeaderActionsContainer>
          <AdminAccountReportCardActions account={account} setOpenModal={setOpenModal} isSuperAdmin={isSuperAdmin} setAccountBeingActioned={setAccountBeingActioned} />
        </CollapsableCardHeaderActionsContainer>
      </CollapsableCardBodyContainer>
    </CollapsableCardCollapseContainer>
  </CollapsableCardContainer>
}

export { AccountCardListCardListItem };
